import FormContainer from './Container';
import FormHeading from './Heading';
import FormAlert from './Alert';
import FormEmailInput from './EmailInput';
import FormPasswordInput from './PasswordInput';
import FormPasswordStrengthMeter from './PasswordStrengthMeter';
import FormTermsLink from './TermsLink';
import FormSubmitButton from './SubmitButton';
import FormLoginMethods from './LoginMethods';
import FormSamlLoginButton from './SamlLoginButton';

//  Export each piece, which can then be used like <AuthForm.SubComponent>
export default {
  Container: FormContainer,
  Heading: FormHeading,
  Alert: FormAlert,
  EmailInput: FormEmailInput,
  PasswordInput: FormPasswordInput,
  PasswordStrengthMeter: FormPasswordStrengthMeter,
  SubmitButton: FormSubmitButton,
  TermsLink: FormTermsLink,
  LoginMethods: FormLoginMethods,
  SamlLoginButton: FormSamlLoginButton,
};
